const LETRA = { FACTURA_A: 'A', FACTURA_B: 'B', FACTURA_C: 'C' };

const CLAVE_FILTROS = 'facturacion_a_quien_filtros';
const CLAVE_MODO = 'facturacion_modo';
const CLAVE_PREFERENCIAS = 'facturacion_a_quien';

const defaultFiltrosValores = {
  cuit: '', razon_social: '', razon_social_prefix: false, activo: 'true', tipo_id: '', grupo_id: '', direccion: '', provincia_id: '', localidad_id: '',
  telefono: '', abono_mensual_min: '', cantidad_empleados: '', saldo_min: '', saldo_max: '',
  condicion_impositiva: '', ingresos_brutos: '', drg: '', dv: '', iva_liquida: '',
  listo: '', faltantes: '', movimientos_min: '', monto_min: '',
};

function filtroActivo(id, filtrosVisibles, columnasVisibles) {
  return filtrosVisibles?.[id] !== false && columnasVisibles?.[id] !== false;
}

function leerFiltrosGuardados() {
  if (typeof sessionStorage === 'undefined') return { ...defaultFiltrosValores };
  return leerFiltrosSesion(sessionStorage.getItem(CLAVE_FILTROS));
}

function guardarFiltrosSesion(filtros) {
  sessionStorage.setItem(CLAVE_FILTROS, JSON.stringify(filtros));
}

function leerModoGuardado() {
  if (typeof sessionStorage === 'undefined') return 'recibo';
  return sessionStorage.getItem(CLAVE_MODO) || 'recibo';
}

function guardarModoSesion(modo) {
  sessionStorage.setItem(CLAVE_MODO, modo);
}

function clavePreferencias() {
  return CLAVE_PREFERENCIAS;
}

function filtrosIniciales() {
  return { ...defaultFiltrosValores };
}

function leerFiltrosSesion(raw) {
  try {
    if (!raw) return { ...defaultFiltrosValores };
    return { ...defaultFiltrosValores, ...JSON.parse(raw) };
  } catch {
    return { ...defaultFiltrosValores };
  }
}

function paramsConsultaClientes(filtrosValores, visible) {
  const params = {};
  if (visible('cuit') && filtrosValores.cuit) params.cuit = filtrosValores.cuit;
  if (visible('razon_social') && filtrosValores.razon_social) {
    params.razon_social = filtrosValores.razon_social;
    if (filtrosValores.razon_social_prefix) params.razon_social_modo = 'prefix';
  }
  if (visible('estado')) params.activo = filtrosValores.activo;
  else params.activo = 'true';
  if (visible('tipo') && filtrosValores.tipo_id) params.tipo_id = filtrosValores.tipo_id;
  if (visible('grupo') && filtrosValores.grupo_id) params.grupo_id = filtrosValores.grupo_id;
  if (visible('direccion') && filtrosValores.direccion) params.direccion = filtrosValores.direccion;
  if (visible('provincia') && filtrosValores.provincia_id) params.provincia_id = filtrosValores.provincia_id;
  if (visible('localidad') && filtrosValores.localidad_id) params.localidad_id = filtrosValores.localidad_id;
  if (visible('telefono') && filtrosValores.telefono) params.telefono = filtrosValores.telefono;
  if (visible('condicion_impositiva') && filtrosValores.condicion_impositiva) params.condicion_impositiva = filtrosValores.condicion_impositiva;
  if (visible('ingresos_brutos') && filtrosValores.ingresos_brutos) params.ingresos_brutos = filtrosValores.ingresos_brutos;
  if (visible('drg') && filtrosValores.drg) params.drg = filtrosValores.drg;
  if (visible('dv') && filtrosValores.dv) params.dv = filtrosValores.dv;
  if (visible('iva_liquida') && filtrosValores.iva_liquida !== '') params.iva_liquida = filtrosValores.iva_liquida;
  if (visible('abono_mensual') && filtrosValores.abono_mensual_min !== '') params.abono_mensual_min = filtrosValores.abono_mensual_min;
  if (visible('empleados') && filtrosValores.cantidad_empleados !== '') params.cantidad_empleados = filtrosValores.cantidad_empleados;
  if (visible('saldo') && filtrosValores.saldo_min !== '') params.saldo_min = filtrosValores.saldo_min;
  if (visible('saldo') && filtrosValores.saldo_max !== '') params.saldo_max = filtrosValores.saldo_max;
  return params;
}

function datosFiscales(fiscal) {
  const movimientos = fiscal.movimientos || [];
  return {
    condicion: fiscal.condicion,
    listo: fiscal.listo,
    faltantes: fiscal.faltantes || [],
    avisos: fiscal.avisos || [],
    movimientos,
    cantidad: movimientos.length,
    monto: movimientos.reduce((acc, m) => acc + Number(m.monto || 0), 0),
  };
}

/** Una fila de grupo pasa los filtros de clientes si pasa la cuenta o alguno de sus integrantes. */
function filaDeGrupo(fiscal, apiPorId) {
  const base = apiPorId.get(fiscal.cliente_id)
    || (fiscal.integrantes || []).map((id) => apiPorId.get(id)).find(Boolean);
  if (!base) return null;
  return {
    ...base,
    id: fiscal.cliente_id ?? base.id,
    clave: `g:${fiscal.grupo_id}`,
    razon_social: fiscal.razon_social || 'Sin cuenta receptora',
    cuit: fiscal.cuit ?? '',
    grupo_nombre: fiscal.grupo_nombre,
    grupoFactura: { id: fiscal.grupo_id, nombre: fiscal.grupo_nombre, integrantes: fiscal.integrantes || [] },
    ...datosFiscales(fiscal),
  };
}

function filasDeCandidatos(clientesApi, candidatos, filtrosValores, visible) {
  const apiPorId = new Map((clientesApi || []).map((c) => [c.id, c]));
  return (candidatos || [])
    .map((fiscal) => {
      if (fiscal.tipo === 'grupo') return filaDeGrupo(fiscal, apiPorId);
      const base = apiPorId.get(fiscal.cliente_id);
      return base ? { ...base, clave: `c:${base.id}`, ...datosFiscales(fiscal) } : null;
    })
    .filter(Boolean)
    .filter((c) => {
      if (visible('listo') && filtrosValores.listo === 'si' && !c.listo) return false;
      if (visible('listo') && filtrosValores.listo === 'no' && c.listo) return false;
      if (visible('faltantes') && filtrosValores.faltantes) {
        const texto = c.faltantes.join(' ').toLowerCase();
        if (!texto.includes(filtrosValores.faltantes.toLowerCase())) return false;
      }
      if (visible('movimientos') && filtrosValores.movimientos_min !== '' && c.cantidad < Number(filtrosValores.movimientos_min)) return false;
      if (visible('monto') && filtrosValores.monto_min !== '' && c.monto < Number(filtrosValores.monto_min)) return false;
      return true;
    });
}

function idsClientesEmitidas({ clientesApi, filas, filtrosVisibles, columnasVisibles, filtrosValores }) {
  const visible = (id) => filtroActivo(id, filtrosVisibles, columnasVisibles);
  const extra = (visible('listo') && filtrosValores.listo)
    || (visible('faltantes') && filtrosValores.faltantes)
    || (visible('movimientos') && filtrosValores.movimientos_min !== '')
    || (visible('monto') && filtrosValores.monto_min !== '');
  return (extra ? filas : clientesApi).map((c) => c.id);
}

/**
 * Las emitidas siguen el mismo recorte que el listado de a quién facturar.
 * Los filtros de listo, faltantes, movimientos y monto achican a las filas ya filtradas.
 */
function filtrarFacturasEmitidas(args) {
  const ids = new Set(idsClientesEmitidas(args));
  return (args.facturas || []).filter((f) => ids.has(f.cliente_id));
}

function claveFila(fila) {
  return fila.clave || `c:${fila.id}`;
}

function idsMarcados(seleccion, fila) {
  return seleccion?.[claveFila(fila)] || [];
}

function filtrarSoloSeleccionadas(filas, seleccion) {
  return (filas || []).filter((fila) => idsMarcados(seleccion, fila).length > 0);
}

/** Separa el lote en pedidos por cliente y por grupo para POST /facturacion/emitir. */
function armarPedidoEmision(filas, seleccion) {
  const clientes = [];
  const grupos = [];
  for (const fila of filas || []) {
    const movimientoIds = idsMarcados(seleccion, fila);
    if (!movimientoIds.length || !fila.listo) continue;
    if (fila.grupoFactura) grupos.push({ grupoId: fila.grupoFactura.id, movimientoIds });
    else clientes.push({ clienteId: fila.id, movimientoIds });
  }
  return { clientes, grupos };
}

function resumenSeleccion(filas, seleccion) {
  let cantidad = 0;
  let importe = 0;
  for (const fila of filas || []) {
    if (fila.listo === false) continue;
    const marcados = new Set(idsMarcados(seleccion, fila));
    if (!marcados.size) continue;
    const movimientos = (fila.movimientos || []).filter((m) => marcados.has(m.id));
    if (!movimientos.length) continue;
    cantidad += 1;
    importe += movimientos.reduce((acc, m) => acc + Number(m.monto || 0), 0);
  }
  return { cantidad, importe };
}

function fechaMinimaEmision(tiposEnJuego, ultimasFechas) {
  let minima = null;
  for (const tipo of tiposEnJuego || []) {
    const ultima = ultimasFechas?.[tipo];
    if (ultima && (!minima || ultima > minima)) minima = ultima;
  }
  return minima;
}

function armarResumenArca(meta) {
  const tipos = meta?.emisor?.condicionEmisor === 'monotributista'
    ? ['FACTURA_C']
    : ['FACTURA_A', 'FACTURA_B'];
  const pv = meta?.emisor?.puntoVenta;
  return tipos
    .filter((tipo) => meta?.proximosNumeros?.[tipo] != null)
    .map((tipo) => ({
      tipo,
      letra: LETRA[tipo],
      fecha: meta?.ultimasFechas?.[tipo] || null,
      numero: `${String(pv || 0).padStart(5, '0')}-${String(meta.proximosNumeros[tipo]).padStart(8, '0')}`,
    }));
}

export {
  clavePreferencias,
  leerFiltrosGuardados,
  guardarFiltrosSesion,
  leerModoGuardado,
  guardarModoSesion,
  filtrosIniciales,
  filtroActivo,
  leerFiltrosSesion,
  paramsConsultaClientes,
  filasDeCandidatos,
  idsClientesEmitidas,
  filtrarFacturasEmitidas,
  filtrarSoloSeleccionadas,
  resumenSeleccion,
  claveFila,
  armarPedidoEmision,
  fechaMinimaEmision,
  armarResumenArca,
};
